export default {"src":"/_next/static/media/circleExclamationMark_24.1f9cee0b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};